var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-bar",class:{ rotated: _vm.currentStageSettings.rotate_timebar },style:(_vm.barStyles)},[_c('i',{staticClass:"progress",class:{ inactive: !_vm.activeCycle },style:(_vm.progressStyle)}),_vm._v(" "),_c('span',{staticClass:"time-unit",domProps:{"innerHTML":_vm._s(_vm.cycleTextHTML)}}),_vm._v(" "),_c('span',{staticClass:"time-unit-elapsed"},[_vm._v(_vm._s(_vm.currentGameCycle))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f0da4b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/TimeBar.vue
// module id = null
// module chunks = 